import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Loader from '@/components/Loader/Loader'
import Accordion from './Sections/accordion/Accordion'
import './style.scss'

export default function Aside() {
  const [asideData, setAsideData] = useState(null)
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    axios
      .get('/data/rektorzy.json')
      .then((res) => {
        setAsideData(res.data)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => setLoading(false))
  }, [])

  if (error) {
    return (
      <div className="alert alert-danger my-3" role="alert">
        Wystąpił błąd.
      </div>
    )
  }

  if (loading) return <Loader size="2" />

  return (
    <aside>
      <div className="mb-3">
        <a
          href="https://rektorzy2020.perspektywy.pl/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <p className="aside__heading h3 text-center f-100 py-2 px-2">
            Poprzednia edycja
          </p>
        </a>
      </div>

      <div className="mb-3">
        <Link to="/article/kalendarium">
          <p className="aside__heading h3 text-center f-100 py-2 px-2">
            Terminarz wyborów <br /> 2024-2028
          </p>
        </Link>
      </div>

      <div className="mb-3">
        <h3 className="aside__heading text-center f-150 py-2 px-1">
          Wybory na kadencję <br /> 2024-2028
        </h3>
        {asideData && <Accordion items={asideData} />}
      </div>

      <div className="mb-3">
        <Link to="/article/rektorzy-w-kadencjach">
          <p className="aside__heading h3 text-center f-125 py-2 px-2">
            Rektorzy w kadencjach <br /> 2002-2028
          </p>
        </Link>
      </div>
    </aside>
  )
}